// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"626":"598a4280","774":"88864201"}[chunkId] + ".chunk.css";
};